export default __webpack_public_path__ + "static/media/Bitmap_7.7fd7ee62.jpg";